import Vue from 'vue'
import Viser from 'viser-vue'

Vue.use(Viser)
